import { combineEpics, ofType } from "redux-observable"
import { Epic } from "../../epics"

import * as actions from "./actions"
import { debounceTime, flatMap, mergeMap } from "rxjs/operators"
import { EMPTY, of } from "rxjs"
import { removeQueryParam, setQueryParam } from "../../util/Url"
import localStorage from "../../util/LocalStorage"
import { ITenForceWindow } from "../../global"
import { DateTime } from "luxon"

declare let window: ITenForceWindow

export const filterTermsEpic: Epic = (action$, _state$) =>
    action$.pipe(
        ofType(actions.FILTER_TERMS),
        debounceTime(500),
        mergeMap(() => of(actions.setDictionaryLoading(false))),
    )

export const selectTermInDictionaryEpic: Epic = (action$, state$) =>
    action$.pipe(
        ofType(actions.SELECT_TERM_IN_DICTIONARY),
        flatMap(() => {
            const {
                contextualHelp: {
                    dictionaryPopup: { selectedTermCode },
                },
            } = state$.value
            if (selectedTermCode) {
                setQueryParam("dictionary", selectedTermCode)
            }
            return EMPTY
        }),
    )

export const selectTooltipEpic: Epic = (action$, _state$) =>
    action$.pipe(
        ofType(actions.SELECT_TERM_IN_TOOLTIPS),
        flatMap(({ term }: actions.TermAction) => {
            if (!term || !term.isHighlighted) {
                return EMPTY
            }
            // If the term was highlighted, we want to mark it as being already "seen" by the current user so it doesn't appear again.
            localStorage.setItem(
                `${window.env.loggedOnPersonId}_contextual-help-term_${term.code}`,
                DateTime.now().toISO() ?? new Date().toISOString(),
            )

            return EMPTY
        }),
    )

export const updateDictionaryPopupVisibilityEpic: Epic = (action$, state$) =>
    action$.pipe(
        ofType(actions.UPDATE_DICTIONARY_POPUP_VISIBILITY),
        flatMap(() => {
            const {
                contextualHelp: { isDictionaryPopupVisible },
            } = state$.value
            if (!isDictionaryPopupVisible) {
                removeQueryParam("dictionary")
            }
            return EMPTY
        }),
    )

export default combineEpics(
    selectTooltipEpic,
    filterTermsEpic,
    selectTermInDictionaryEpic,
    updateDictionaryPopupVisibilityEpic,
)
